import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { ChatTabsData } from "../../../../../Data/Messenger/Messenger";
import { useAppDispatch, useAppSelector } from "../../../../../ReduxToolkit/Hooks";
import { setSubChatActiveTab } from "../../../../../ReduxToolkit/Reducers/Messenger/Messenger";
import GroupChat from "./GroupChat";
import PrivateChat from "./PrivateChat";

const ChatTab = () => {
  const dispatch = useAppDispatch();
  const { subChatActiveTab } = useAppSelector((state) => state.messenger);
  return (
    <div className="template-tab">
      <Nav tabs className="pb-0">
        {ChatTabsData.map((item, index) => (
          <NavItem key={index}>
            <NavLink className={`button-effect ${subChatActiveTab === item.type ? "active" : ""}`} onClick={() => dispatch(setSubChatActiveTab(item.type))}>
              {item.title}
            </NavLink>
          </NavItem>
        ))}
      </Nav>
      <TabContent activeTab={subChatActiveTab}>
        <TabPane tabId="direct">
          <PrivateChat />
        </TabPane>
        <TabPane tabId="group">
          <GroupChat />
        </TabPane>
      </TabContent>
    </div>
  );
};

export default ChatTab;
